import { v4 as uuid } from "uuid";
import { z } from "zod";
export const projectLevelSpendCommitmentType = [];
export var SocialCommitmentTypeSpend;
(function (SocialCommitmentTypeSpend) {
    SocialCommitmentTypeSpend["DefaultSpend"] = "social-commitment-type_default_spend";
    SocialCommitmentTypeSpend["SocialDisabilityEnterpriseSpend"] = "social-commitment-type_social-disability-enterprise-spend";
    SocialCommitmentTypeSpend["AboriginalTorresStraitIslanderBusinessSpend"] = "social-commitment-type_aboriginal-torres-strait-island-business-spend";
    SocialCommitmentTypeSpend["GeespApprenticeProgram"] = "social-commitment-type_geesp-apprentice-program";
    // South Australia
    SocialCommitmentTypeSpend["SASpend"] = "social-commitment-type_sa-spend";
    SocialCommitmentTypeSpend["AboriginalBusinessSpend"] = "social-commitment-type_aboriginal-business-spend";
    // Queensland
    SocialCommitmentTypeSpend["LoganGCLocalProcurement"] = "social-commitment-type_logan-gc-local-procurement";
    SocialCommitmentTypeSpend["SmallMediumEnterprises"] = "social-commitment-type_small-medium-enterprises";
    // ACT
    SocialCommitmentTypeSpend["ACTFirstNationsBusinessSpend"] = "social-commitment-type_act-first-nations-business-spend";
})(SocialCommitmentTypeSpend || (SocialCommitmentTypeSpend = {}));
export const socialSpendCommitmentTypeToString = (socialCommitmentType) => {
    switch (socialCommitmentType) {
        case SocialCommitmentTypeSpend.DefaultSpend:
            return "Custom Spend";
        case SocialCommitmentTypeSpend.SocialDisabilityEnterpriseSpend:
            // Social Enterprise Spend
            return "Social Disability Enterprise Spend";
        case SocialCommitmentTypeSpend.AboriginalTorresStraitIslanderBusinessSpend:
            return "Indigenous Business Spend";
        case SocialCommitmentTypeSpend.GeespApprenticeProgram:
            return "GEESP Disadvantage Costs";
        // South Australia
        case SocialCommitmentTypeSpend.SASpend:
            return "SA Spend";
        case SocialCommitmentTypeSpend.AboriginalBusinessSpend:
            return "Aboriginal Business Spend";
        // Queensland
        case SocialCommitmentTypeSpend.LoganGCLocalProcurement:
            return "Logan GC Local Procurement";
        case SocialCommitmentTypeSpend.SmallMediumEnterprises:
            return "Small - Medium Enterprise Procurement";
        // ACT
        case SocialCommitmentTypeSpend.ACTFirstNationsBusinessSpend:
            return "First Nations Business Addressable Spend";
    }
};
export const socialSpendCommitmentTypeToAbbreviatedString = (targetName) => {
    switch (targetName) {
        default:
        case SocialCommitmentTypeSpend.DefaultSpend:
            return "Custom";
        case SocialCommitmentTypeSpend.SocialDisabilityEnterpriseSpend:
            return "SDES";
        case SocialCommitmentTypeSpend.AboriginalTorresStraitIslanderBusinessSpend:
            return "IS";
        // South Australia
        case SocialCommitmentTypeSpend.SASpend:
            return "SAS";
        case SocialCommitmentTypeSpend.AboriginalBusinessSpend:
            return "ABS";
        // Queensland
        case SocialCommitmentTypeSpend.LoganGCLocalProcurement:
            return "LGCLP";
        case SocialCommitmentTypeSpend.SmallMediumEnterprises:
            return "SME";
        // ACT
        case SocialCommitmentTypeSpend.ACTFirstNationsBusinessSpend:
            return "FNBS";
    }
};
export const socialSpendCommitmentTypeToDescription = (socialCommitmentType) => {
    switch (socialCommitmentType) {
        default:
        case SocialCommitmentTypeSpend.DefaultSpend:
            return "Custom Spend: Description missing - please contact support";
        case SocialCommitmentTypeSpend.SocialDisabilityEnterpriseSpend:
            return "Value of goods, services and construction carried out by certified Social Enterprises or Australian Disability Enterprises under the Social Procurement Framework (SPF).";
        case SocialCommitmentTypeSpend.AboriginalTorresStraitIslanderBusinessSpend:
            return "An organisation, operating a business, that is 50% or more Indigenous-owned, as certified by Kinaway or Supply Nation. A social enterprise or registered charity may also be an Indigenous enterprise if it is operating a business.";
        // South Australia
        case SocialCommitmentTypeSpend.SASpend:
            return "Local Industry (SA Spend) - region specific spend within 125km of project address in South Australia.";
        case SocialCommitmentTypeSpend.AboriginalBusinessSpend:
            return "Aboriginal owned Business Spend for South Australia projects.";
        // Queensland
        case SocialCommitmentTypeSpend.LoganGCLocalProcurement:
            return "Logan GC Local Procurement - region specific spend within specified postcodes and 125km of project address.";
        case SocialCommitmentTypeSpend.SmallMediumEnterprises:
            return "Small - Medium Enterprise Procurement target for Queensland projects.";
        // ACT
        case SocialCommitmentTypeSpend.ACTFirstNationsBusinessSpend:
            return "First Nations Business Addressable Spend for ACT projects.";
    }
};
export const packageSocialSpendCommitmentLineItemSchema = z.object({
    created: z.date(),
    deleted: z.boolean().optional(),
    id: z.string(),
    packageId: z.string(),
    projectId: z.string(),
    projectSocialSpendCommitmentId: z.string(),
    targetDescription: z.string().optional(),
    targetName: z.enum(SocialCommitmentTypeSpend),
    targetValue: z.number(),
    targetValueRealised: z.number()
});
export const cloneProjectSpendCommitmentsForPackage = (packageId, commitments) => {
    return commitments
        .map((c) => {
        return {
            ...c,
            achievedValue: 0,
            id: uuid(),
            packageId,
            projectSocialSpendCommitmentId: c.id
        };
    })
        .filter((c) => !projectLevelSpendCommitmentType.includes(c.targetName));
};
export const cloneProjectSpendCommitmentsFromPackage = (packageId, commitments) => {
    return commitments
        .map((c) => {
        return {
            ...c,
            achievedValue: 0,
            id: uuid(),
            packageId,
            projectSocialSpendCommitmentId: c.projectSocialSpendCommitmentId
        };
    })
        .filter((c) => !projectLevelSpendCommitmentType.includes(c.targetName));
};
export const projectToPackageSocialSpendCommitment = (packageId, commitment) => {
    return {
        contractor_package_id: packageId,
        created: commitment.created,
        package_social_spend_commitment_id: uuid(),
        project_id: commitment.project_id,
        project_social_spend_commitment_id: commitment.project_social_spend_commitment_id,
        target_description: commitment.target_description,
        target_type: commitment.target_type,
        target_value: commitment.target_value,
        target_value_realised: commitment.target_value_realised
    };
};
